import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatAmount(val: any): string {
  const num = parseFloat(val)
  if (isNaN(num)) return '0,00'
  return new Intl.NumberFormat('fr-FR', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  }).format(num)
}

export function formatDateFr(dateStr: string | null): string {
  if (!dateStr) return ''
  const parts = dateStr.includes('-') ? dateStr.split('-') : dateStr.split('/')
  if (parts.length !== 3) return dateStr
  if (parts[0].length === 4) return `${parts[2]}/${parts[1]}/${parts[0]}`
  return dateStr
}

export function slugify(text: string): string {
  if (!text) return ''
  return text
    .toString()
    .normalize('NFD')                   // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '')   // remove diacritical marks
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')              // replace spaces with -
    .replace(/[^\w-]+/g, '')           // remove all non-word chars
    .replace(/--+/g, '-')              // replace multiple - with single -
    .replace(/^-+/, '')                // trim - from start of text
    .replace(/-+$/, '')                // trim - from end of text
}
